import React from "react";
import SocialMedia from "./SocialMedia";

const Footer = ({
  social_urls,
  bgColor = "dark",
  textColor = "light",
  iconsColor = "light",
}) => {
  return (
    <footer className={`bg-${bgColor} text-${textColor} py-2 mt-2`}>
      <div className="container text-center">
        {/* small follow us */}
        {/* <small>Follow us</small> */}
        
        <SocialMedia social_urls={social_urls} color={`text-${iconsColor}`} />

        {/* Divider */}
        <div className="my-2"
          style={{
            width: "100%",
            height: "1px",
            background: "rgba(255,255,255,0.15)",
          }}
        ></div>

        {/* Powered by Picloud */}

        <a
          href="https://www.pic-loud.com"
          className="text-decoration-none d-flex flex-column justify-content-center align-items-center"
          style={{
            opacity: 0.85,
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.opacity = "1";
            e.currentTarget.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.opacity = "0.85";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          <small
            className="mt-1"
            style={{
              opacity: 0.75,
              fontSize: "0.75rem",
              letterSpacing: "0.5px",
              color: textColor === "light" ? "#ffffff" : "#000000",
            }}
          >
            Powered by Pic-loud
          </small>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
